import {
	FILTER_DARES_FORM_MODULE_ID,
} from 'root/src/shared/descriptions/modules/moduleIds'

import setSortFilter from 'root/src/client/logic/form/thunks/setSortFilter'

export default {
	[FILTER_DARES_FORM_MODULE_ID]: [
		{
			action: setSortFilter,
		},
	],
}
